export default __webpack_public_path__ + "static/media/warning--offset-roads--g3.faa03178.png";